import { useDispatch } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { setupScheduledTasks } from '../../redux/actions/tasks';

const SetupTasks = ({ id: clientId }: any) => {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(setupScheduledTasks(clientId));
  };
  return (
    <Button primary onClick={handleClick}>
      Setup Tasks
    </Button>
  );
};

export default SetupTasks;
